import { render, staticRenderFns } from "./uploadTip-editor.vue?vue&type=template&id=32c9310d&scoped=true&"
import script from "./uploadTip-editor.vue?vue&type=script&lang=js&"
export * from "./uploadTip-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c9310d",
  null
  
)

export default component.exports